import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useTime } from '../../context/tmo'
const TopBar = ({ asesor, anexo, numeroMarcado }) => {
   

  return (
    <Box
      display="flex"
      justifyContent="space-around"
      alignItems="center"
      sx={{
        bgcolor: (theme) => theme.palette.primary.main,
        color: (theme) => theme.palette.primary.contrastText,
        p: 2
      }}
    >
      <Typography variant="body1">Asesor: {asesor}</Typography>
      <Typography variant="body1">Número Marcado: {numeroMarcado}</Typography>
      <Typography variant="body1">Cronómetro: {useTime()}</Typography>
    </Box>
  );
};

export default TopBar;
